import React from 'react'
import { motion, Variants } from 'framer-motion'
import { fadeUpVariants } from '../utils/animations'

/**
 * AnimatedSection - Wrapper component for scroll-triggered animations
 *
 * Features:
 * - Fade up animation when scrolling into view
 * - Only animates once (viewport.once: true)
 * - Respects prefers-reduced-motion
 * - Content visible if JS disabled (SSR-friendly)
 *
 * @example
 * <AnimatedSection>
 *   <YourComponent />
 * </AnimatedSection>
 */

interface AnimatedSectionProps {
  children: React.ReactNode
  className?: string
  variants?: Variants
  delay?: number
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  className = '',
  variants = fadeUpVariants,
  delay = 0,
}) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-100px' }}
      variants={variants}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.div>
  )
}

export default AnimatedSection
